module.exports = __webpack_public_path__ + "img/20210625_Teilkauf_2926.35f5b0c7.png";